export const revertNoScroll = (): void => {
    document.body.classList.remove('no-scroll');
};
